module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.locked ? "Pager locked" : "Pager"
  }, [_c('div', {
    class: _vm.current == _vm.total ? "more disabled" : "more",
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 561 561"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 561 561",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M280.5,76.5V0l-102,102l102,102v-76.5c84.15,0,153,68.85,153,153c0,25.5-7.65,51-17.85,71.4l38.25,38.25\n\t\t\t\t\tC471.75,357,484.5,321.3,484.5,280.5C484.5,168.3,392.7,76.5,280.5,76.5z M280.5,433.5c-84.15,0-153-68.85-153-153\n\t\t\t\t\tc0-25.5,7.65-51,17.85-71.4l-38.25-38.25C89.25,204,76.5,239.7,76.5,280.5c0,112.2,91.8,204,204,204V561l102-102l-102-102V433.5z"
    }
  })])]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('span', {
    class: _vm.current == 1 ? "prev disabled" : "prev",
    on: {
      "click": function($event) {
        return _vm.prev()
      }
    }
  }, [_c('svg', {
    staticClass: "feather feather-arrow-left",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "20",
      "y1": "12",
      "x2": "4",
      "y2": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "none",
      "points": "10 18 4 12 10 6"
    }
  })])]), _vm._v(" "), (_vm.total <= _vm.numOfVisible * 2) ? [_vm._l((_vm.total), function(page) {
    return [_c('span', {
      class: page == _vm.current ? "active" : false,
      on: {
        "click": function($event) {
          return _vm.goto(page)
        }
      }
    }, [_vm._v(_vm._s(page))])]
  })] : [(_vm.showFirst) ? [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goto(1)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.goto(_vm.chunks[_vm.currentChunkIndex - 1][_vm.chunks[_vm.currentChunkIndex - 1].length - 1])
      }
    }
  }, [_vm._v("...")])] : _vm._e(), _vm._v(" "), (!_vm.end) ? [_vm._l((_vm.current_chunk), function(page) {
    return [_c('span', {
      class: page == _vm.current ? "active" : false,
      on: {
        "click": function($event) {
          return _vm.goto(page)
        }
      }
    }, [_vm._v(_vm._s(page))])]
  })] : [_vm._l((_vm.current_chunk), function(page) {
    return [_c('span', {
      class: page == _vm.current ? "active" : false,
      on: {
        "click": function($event) {
          return _vm.goto(page)
        }
      }
    }, [_vm._v(_vm._s(page))])]
  })], _vm._v(" "), (_vm.showLast) ? [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goto(_vm.chunks[_vm.currentChunkIndex + 1][0])
      }
    }
  }, [_vm._v("...")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.goto(_vm.total)
      }
    }
  }, [_vm._v(_vm._s(_vm.total))])] : _vm._e()], _vm._v(" "), _c('span', {
    class: _vm.current == _vm.total ? "next disabled" : "next",
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_c('svg', {
    staticClass: "feather feather-arrow-left",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "20",
      "y1": "12",
      "x2": "4",
      "y2": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "none",
      "points": "10 18 4 12 10 6"
    }
  })])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50011091"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/Pager.vue
// module id = 247
// module chunks = 35